// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GXH3u","badges":"styles_badges__3sNBt"};